const prefix = 'NOTIFICATIONS/';
export const GET_NOTIFICATIONS = `${prefix}GET_NOTIFICATIONS`;
export const SET_NOTIFICATIONS = `${prefix}SET_NOTIFICATIONS`;
export const POST_MARK_AS_READ_NOTIFICATIONS = `${prefix}POST_MARK_AS_READ_NOTIFICATIONS`;
export const SET_MARK_AS_READ_NOTIFICATIONS = `${prefix}SET_MARK_AS_READ_NOTIFICATIONS`;
export const SET_NOTIFICATIONS_LOADING = `${prefix}SET_NOTIFICATIONS_LOADING`;
export const SET_READ_NOTIFICATION = `${prefix}SET_READ_NOTIFICATION`;

export const postMarkAsReadNotifications = data => ({ type: POST_MARK_AS_READ_NOTIFICATIONS, data });
